<div class="mx-auto max-w-4xl space-y-4 p-4">

  <div>
    <h1 class="text-xl font-bold tracking-tight text-gray-900">Plattform</h1>
    <p class="mt-1 text-sm text-gray-500">
      Einstellungen, die für die gesamte Installation gelten. Jede Angabe wird an genau einer Stelle gelesen.
      Welche das ist, steht unter dem jeweiligen Feld.
    </p>
  </div>

  <!-- ── Öffentliche Adresse ──────────────────────────────────────────────────────────────────────────────
       Scheme + host, nothing else: the Telegram password bot appends `/static/privacy.html`, so a stored path
       would produce a link into the middle of nowhere. -->
  <section aria-labelledby="platform-domain-title"
           class="rounded-2xl border-[1px] border-gray-100 bg-white p-4 shadow-sm">
    <h2 class="text-base font-bold tracking-tight text-gray-800" id="platform-domain-title">
      Öffentliche Adresse
    </h2>
    <p class="mt-1 text-xs text-gray-500">
      Die Adresse, unter der diese Installation im Internet erreichbar ist.
    </p>

    <div class="mt-3">
      <label class="mb-2 block text-sm font-bold tracking-tight text-gray-700" for="platform-domain">
        Adresse
      </label>
      <div class="flex flex-col gap-2 sm:flex-row">
        <input (input)="domain.set(value($event))" [disabled]="loading()" [value]="domain()"
               class="block w-full rounded-xl border-[1px] border-gray-200 bg-white px-3 py-2.5 text-gray-900
                      shadow-sm transition-all duration-200 placeholder-gray-300 focus:border-theme-primary-500
                      focus:ring-1 focus:ring-theme-primary-500 disabled:bg-gray-50 sm:text-sm"
               id="platform-domain" inputmode="url" name="platform-domain"
               placeholder="https://app.example.de" type="text">
        <button (click)="saveDomain(domain())" [disabled]="loading() || savingDomain()"
                class="inline-flex shrink-0 items-center justify-center rounded-2xl bg-theme-primary-600 px-5
                       py-2.5 font-semibold text-white shadow-lg shadow-theme-primary-100 transition-all
                       duration-200 hover:bg-theme-primary-700 hover:shadow-xl active:scale-95
                       disabled:cursor-not-allowed disabled:opacity-30 disabled:grayscale sm:text-sm"
                type="button">
          Speichern
        </button>
      </div>
      <p class="mt-2 text-xs text-gray-500">
        Nur Adresse und Hostname, ohne Pfad, z. B. <span class="font-mono">https://app.example.de</span>.
        Der Telegram-Bot hängt daran den Link zur Datenschutzerklärung an. Leer lassen entfernt die Angabe.
      </p>
    </div>
  </section>

  <!-- ── Register-App ─────────────────────────────────────────────────────────────────────────────────────
       These two are a COMPARISON TARGET, not a push. Their only reader is the shard device list
       (`_modules/signalRTracker/devices/devices.component.html`), which rides them in on the SignalR group
       model and marks a device red under „App-Version" when its reported version or build differs. Nothing
       here reaches a register, and the copy must not suggest it does. -->
  <section aria-labelledby="platform-app-title"
           class="rounded-2xl border-[1px] border-gray-100 bg-white p-4 shadow-sm">
    <h2 class="text-base font-bold tracking-tight text-gray-800" id="platform-app-title">Register-App</h2>
    <p class="mt-1 text-xs text-gray-500">
      Die Soll-Version der Register-App.
    </p>

    <div class="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div>
        <label class="mb-2 block text-sm font-bold tracking-tight text-gray-700" for="platform-app-version">
          Version
        </label>
        <input (input)="appVersion.set(value($event))" [disabled]="loading()" [value]="appVersion()"
               class="block w-full rounded-xl border-[1px] border-gray-200 bg-white px-3 py-2.5 text-gray-900
                      shadow-sm transition-all duration-200 placeholder-gray-300 focus:border-theme-primary-500
                      focus:ring-1 focus:ring-theme-primary-500 disabled:bg-gray-50 sm:text-sm"
               id="platform-app-version" name="platform-app-version" placeholder="z. B. 1.7.3" type="text">
      </div>
      <div>
        <label class="mb-2 block text-sm font-bold tracking-tight text-gray-700" for="platform-app-build">
          Build
        </label>
        <input (input)="appBuild.set(value($event))" [disabled]="loading()" [value]="appBuild()"
               class="block w-full rounded-xl border-[1px] border-gray-200 bg-white px-3 py-2.5 text-gray-900
                      shadow-sm transition-all duration-200 placeholder-gray-300 focus:border-theme-primary-500
                      focus:ring-1 focus:ring-theme-primary-500 disabled:bg-gray-50 sm:text-sm"
               id="platform-app-build" name="platform-app-build" placeholder="z. B. 4211" type="text">
      </div>
    </div>

    <!-- Helper and button on ONE row from `sm` up, exactly as on the Fiskaly credentials block: a button
         alone on a right-aligned row leaves its explanation stranded under empty space. Stacked below `sm`,
         sentence first, button full width. -->
    <div class="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <p class="text-xs text-gray-500">
        Geräte, die in der Geräteliste eines Standorts eine andere Version oder einen anderen Build melden,
        werden dort rot markiert. Leer lassen schaltet die Prüfung für die jeweilige Angabe ab.
      </p>
      <button (click)="saveApp(appVersion(), appBuild())" [disabled]="loading() || savingApp()"
              class="inline-flex w-full shrink-0 items-center justify-center rounded-2xl bg-theme-primary-600
                     px-5 py-2.5 font-semibold text-white shadow-lg shadow-theme-primary-100 transition-all
                     duration-200 hover:bg-theme-primary-700 hover:shadow-xl active:scale-95
                     disabled:cursor-not-allowed disabled:opacity-30 disabled:grayscale sm:w-auto sm:text-sm"
              type="button">
        Speichern
      </button>
    </div>
  </section>
</div>
